import { render, staticRenderFns } from "./cookie-tab.vue?vue&type=template&id=6d4e7209"
import script from "./cookie-tab.vue?vue&type=script&lang=js"
export * from "./cookie-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports